import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// Fetch media press release data
export const mediaPressReleaseData = createAsyncThunk(
  "media/mediaPressReleaseData",
  async (FinancialYear, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/press-releases/getlist?year=${FinancialYear}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

//Fetch news data
export const mediaNewsData = createAsyncThunk(
  "media/mediaNewsData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/news/getlist?brand=AWW`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const mediaSlice = createSlice({
  name: "media",
  initialState: {
    pressReleaseData: null,
    loading: false,
    error: null,
    newsData:null
  },
  extraReducers: (builder) => {
    builder
      // pressReleaseData data
      .addCase(mediaPressReleaseData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(mediaPressReleaseData.fulfilled, (state, action) => {
        state.loading = false;
        state.pressReleaseData = action.payload;
      })
      .addCase(mediaPressReleaseData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

       // newsData data
       .addCase(mediaNewsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(mediaNewsData.fulfilled, (state, action) => {
        state.loading = false;
        state.newsData = action.payload;
      })
      .addCase(mediaNewsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default mediaSlice.reducer;
